import { Pipe, PipeTransform } from '@angular/core';
import {
  GridRegistrationTypeConst,
  GridRegistrationTypeEnum,
  PhasesTypeEnum
} from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { ShowErrorModel } from '@bo-client/shared/form-errors/errors-form-model';
import { PhasesTypeDisplayNames } from '@bo-client/activation-management/grid-registration/model/producer.model';
import { ErrorStepsEnum } from '@bo-client/activation-management/shared/forms/create-forms-errors-model';

@Pipe({
  name: 'gridRegistrationTypePipe'
})
export class GridRegistrationTypePipe implements PipeTransform {
  transform(value: GridRegistrationTypeEnum) {
    const idx = GridRegistrationTypeConst.findIndex((ele) => ele.value == value);
    let textFound = 'not found';
    if (idx != -1) {
      textFound = GridRegistrationTypeConst[idx].displayName;
    }
    return textFound;
  }
}

@Pipe({
  name: 'gridRegistrationErrorStepsPipe'
})
export class GridRegistrationErrorStepsPipe implements PipeTransform {
  transform(listErrors: ShowErrorModel[], stepName: ErrorStepsEnum) {
    for (let i = 0; i < listErrors.length; i++) {
      if (listErrors[i].step == stepName) {
        return true;
      }
    }
    return false;
  }
}

@Pipe({
  name: 'gridRegistrationErrorListStepsPipe'
})
export class GridRegistrationListErrorStepsPipe implements PipeTransform {
  transform(listErrors: ShowErrorModel[], stepName: ErrorStepsEnum) {
    return listErrors.filter((x) => x.step == stepName);
  }
}

export type ConnectedPhasenOption = { displayName: string; value: unknown };

@Pipe({
  name: 'gridRegistrationConnectedPhasenPipe'
})
export class GridRegistrationConnectedPhasenPipe implements PipeTransform {
  transform(listConnectedPhasen: ConnectedPhasenOption[], value: PhasesTypeEnum | null | undefined) {
    if (value == null) {
      return listConnectedPhasen;
    }
    const phaseCountLabel = PhasesTypeDisplayNames[value];
    if (phaseCountLabel == null) {
      return listConnectedPhasen;
    }
    const phasesNumber = Number(phaseCountLabel);
    if (Number.isNaN(phasesNumber)) {
      return listConnectedPhasen;
    }
    return listConnectedPhasen.filter((ele) => {
      const lCount = ele.displayName.match(/L/g)?.length ?? 0;
      return lCount === phasesNumber;
    });
  }
}
